import React, {RefObject} from 'react';
import {t} from 'lib/i18n';

/**
 * 편집각 컴포넌트
 */

interface IEditangle {
  checkRef: RefObject<HTMLInputElement>;
  onClickEditangle: () => void;
}

const Editangle = ({checkRef, onClickEditangle}: IEditangle) => {
  return (
    <div className='checkbox_wrap'>
      <input
        type='checkbox'
        id='check1'
        className='checkbox'
        ref={checkRef}
        onClick={onClickEditangle}
      />
      <label htmlFor='check1'>{t('편집각 노출')}</label>
    </div>
  );
};

export default Editangle;
